import { useMemo } from "react";
import { Colors } from "@/constants/ThemeColours";
import { useColorScheme } from "@/hooks/useColorScheme";
import { getComponentThemes, type IComponentThemes } from "@/constants/themes/components";

/**
 * Hook providing the full 7-domain component theme bundle for the active color scheme.
 * Memoized against theme changes to guarantee high rendering performance.
 *
 * @returns Fully resolved IComponentThemes bundle (palette, isDark, button, popupMenu, selector, chip, card, symbol, inputForm).
 */
export function useComponentTheme(): IComponentThemes {
  const rawTheme = useColorScheme();
  const isDark = rawTheme === "dark";
  const theme: "light" | "dark" = isDark ? "dark" : "light";
  const palette = Colors[theme] ?? Colors.light;

  return useMemo(() => getComponentThemes(palette, isDark), [palette, isDark]);
}

export default useComponentTheme;
